import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core';

export const AccordionSummary = withStyles({
  root: {
    minHeight: 95,
    padding: '0 39px',
    borderRadius: '15px',
    '&$expanded': {
      minHeight: 95,
    },
  },
  expanded: {},
})(MuiAccordionSummary);
